<svg:g
  (mouseover)="handleMouseEvent($event, 'wholeShape')"
  (mouseout)="handleMouseEvent($event, 'wholeShape')"
>
  <svg:g
    h3ShapeFill
    [selected]="selected"
    [points]="points$ | async"
    [visibility]="visibility$ | async"
    [scale$]="scale$"
    (mousedown)="handleMouseEvent($event, 'shape')"
    (dblclick)="handleMouseEvent($event, 'shape')"
    (mouseup)="handleMouseEvent($event, 'shape')"
  />
  <ng-container *ngIf="showBorderAndSubpoints$ | async">
    <svg:g h3InteractiveBorder [points$]="points$" [shapeStore]="shapeStore" />
    <svg:g
      *ngFor="
        let subpointInfo of allSubpointInfo$ | async;
        trackBy: trackByIndex
      "
      [h3Subpoint]="subpointInfo"
      [shapeSelected]="selected"
      (mousedown)="
        handleMouseEvent($event, 'subpoint', subpointInfo.subpointIndex)
      "
      (dblclick)="handleMouseEvent($event, 'shape')"
    />
  </ng-container>
</svg:g>
<svg:g
  *ngIf="showModelInputPoints$ | async"
  h3ModelInputPoints
  [shapeStore]="shapeStore"
/>
